import {
  toRef,
} from "vue";

import EventBus from "aloha-vue/src/utils/EventBus";

export default function EventBusesAPI(props, {
  addRow = () => {},
  deleteRow = () => {},
  reloadData = () => {},
  updateRow = () => {},
}) {
  const id = toRef(props, "id");

  const initEventBuses = () => {
    EventBus.$on(`updateTable${ id.value }`, reloadData);
    EventBus.$on(`updateRow${ id.value }`, updateRow);
    EventBus.$on(`addRow${ id.value }`, addRow);
    EventBus.$on(`deleteRow${ id.value }`, deleteRow);
  };

  const destroyEventBusses = () => {
    EventBus.$off(`updateTable${ id.value }`, reloadData);
    EventBus.$off(`updateRow${ id.value }`, updateRow);
    EventBus.$off(`addRow${ id.value }`, addRow);
    EventBus.$off(`deleteRow${ id.value }`, deleteRow);
  };

  return {
    destroyEventBusses,
    initEventBuses,
  };
}
